import {
  ArrowDownOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  ExclamationCircleOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { Button, Card, Col, Modal, Row, Statistic } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import GetUnitPerformanceApi from "../../api/units/GetUnitPerformanceApi";

function UnitPlansInfoModal(props) {
  const [unitDetails, setUnitDetails] = useState();
  const perfCycleState = useSelector((state) => state.perfCycleState.value);

  useEffect(() => {
    if (props.unitId) {
      getUnitData();
    }
  }, [props.unitId]);

  async function getUnitData() {
    const apiResponse = await GetUnitPerformanceApi(
      props.unitId,
      perfCycleState.id
    );
    if (apiResponse.message === "success") {
      setUnitDetails(apiResponse);
    }
  }

  return (
    <Modal
      title={unitDetails?.unit?.name || "..."}
      visible={props.visible}
      onCancel={props.handleCancel}
      footer={null}
    >
      <div className="flex justify-between mb-6">
        <Statistic
          title="CURRENT PROGRESS"
          value={unitDetails?.currentProgress || 0}
          prefix={<ArrowDownOutlined style={{ color: "red" }} />}
          suffix="% completed"
        />
        <Link to={`/units/${unitDetails?.unit?.id}`}>
          <Button>View more</Button>
        </Link>
      </div>
      <Card
        style={{
          borderColor: "#e5e7eb",
          marginBottom: "24px",
          cursor: "pointer",
        }}
      >
        <div className="text-base pri-font mb-3">Objectives</div>
        <Row gutter={12}>
          <Col span={6}>
            <Statistic
              valueStyle={{ color: "blue" }}
              prefix={<QuestionCircleOutlined />}
              title="TOTAL"
              value={unitDetails?.objectives?.Total || 0}
            />
          </Col>
          <Col span={6}>
            <Statistic
              valueStyle={{ color: "green" }}
              prefix={<CheckCircleOutlined />}
              title="ON TRACK"
              value={unitDetails?.objectives?.OnTrack || 0}
            />
          </Col>
          <Col span={6}>
            <Statistic
              valueStyle={{ color: "orange" }}
              prefix={<ClockCircleOutlined />}
              title="OFF TRACK"
              value={unitDetails?.objectives?.OffTrack || 0}
            />
          </Col>
          <Col span={6}>
            <Statistic
              valueStyle={{ color: "red" }}
              prefix={<ExclamationCircleOutlined />}
              title="AT RISK"
              value={unitDetails?.objectives?.AtRisk || 0}
            />
          </Col>
        </Row>
      </Card>
    </Modal>
  );
}

export default UnitPlansInfoModal;
